/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Warmup } from './Warmup';
import type { YearWeek } from './YearWeek';
import type { Exercise } from './Exercise';
import type { Assessment } from './Assessment';
/**
 * 
 * @export
 * @interface Calendar
 */
export interface Calendar {
    /**
     * 
     * @type {Date}
     * @memberof Calendar
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof Calendar
     */
    yearWeek?: number;
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof Calendar
     */
    assessments?: Array<Assessment> | null;
    /**
     * 
     * @type {Array<Exercise>}
     * @memberof Calendar
     */
    exercises?: Array<Exercise> | null;
    /**
     * 
     * @type {Array<Warmup>}
     * @memberof Calendar
     */
    warmups?: Array<Warmup> | null;
    /**
     * 
     * @type {YearWeek}
     * @memberof Calendar
     */
    yearWeekNavigation?: YearWeek;
}

/**
 * Check if a given object implements the Calendar interface.
 */
export function instanceOfCalendar(value: object): value is Calendar {
    return true;
}

export function CalendarFromJSON(json: any): Calendar {
    return CalendarFromJSONTyped(json, false);
}

export function CalendarFromJSONTyped(json: any, ignoreDiscriminator: boolean): Calendar {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'yearWeek': json['yearWeek'] == null ? undefined : json['yearWeek'],
        'assessments': json['assessments'] == null ? undefined : ((json['assessments'] as Array<any>).map((require('./Assessment') as typeof import('./Assessment')).AssessmentFromJSON)),
        'exercises': json['exercises'] == null ? undefined : ((json['exercises'] as Array<any>).map((require('./Exercise') as typeof import('./Exercise')).ExerciseFromJSON)),
        'warmups': json['warmups'] == null ? undefined : ((json['warmups'] as Array<any>).map((require('./Warmup') as typeof import('./Warmup')).WarmupFromJSON)),
        'yearWeekNavigation': json['yearWeekNavigation'] == null ? undefined : (require('./YearWeek') as typeof import('./YearWeek')).YearWeekFromJSON(json['yearWeekNavigation']),
    };
}

export function CalendarToJSON(json: any): Calendar {
    return CalendarToJSONTyped(json, false);
}

export function CalendarToJSONTyped(value?: Calendar | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'yearWeek': value['yearWeek'],
        'assessments': value['assessments'] == null ? undefined : ((value['assessments'] as Array<any>).map((require('./Assessment') as typeof import('./Assessment')).AssessmentToJSON)),
        'exercises': value['exercises'] == null ? undefined : ((value['exercises'] as Array<any>).map((require('./Exercise') as typeof import('./Exercise')).ExerciseToJSON)),
        'warmups': value['warmups'] == null ? undefined : ((value['warmups'] as Array<any>).map((require('./Warmup') as typeof import('./Warmup')).WarmupToJSON)),
        'yearWeekNavigation': (require('./YearWeek') as typeof import('./YearWeek')).YearWeekToJSON(value['yearWeekNavigation']),
    };
}

